import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/google_maps.png'


const _withScopeId = n => (_pushScopeId("data-v-b7695882"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "route-gmaps-button"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "google_logo",
  width: "50"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { FORMATS, SIZES } from '@/enums/components'
import BaseButton from '@/components/BaseButton.vue'
import { computed, PropType } from 'vue'
import { getRouteGoogleMapsUrl } from '@/utils/route-planner'
import { Route } from '@/models/public/routePlanner.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsButton',
  props: {
  route: {
    type: Object as PropType<Route | null>,
    default: null,
  },
},
  setup(__props) {

const props = __props



const shouldDisplay = computed(
  () => props.route && props.route.start_point && props.route.end_point,
)
const googleMapsUrl = computed(() => getRouteGoogleMapsUrl(props.route))

const handleClick = () => {
  if (!googleMapsUrl.value) return

  window.open(googleMapsUrl.value, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_unref(shouldDisplay))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: _unref(googleMapsUrl),
          target: "_blank"
        }, _hoisted_4, 8, _hoisted_2),
        _createVNode(BaseButton, {
          label: 'Ava Google Maps rakenduses',
          size: _unref(SIZES).SMALL,
          format: _unref(FORMATS).TERTIARY,
          class: "route-gmaps-button__button",
          onClick: handleClick
        }, null, 8, ["size", "format"])
      ]))
    : _createCommentVNode("", true)
}
}

})